let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("WsRz5")).then(() => parcelRequire('57Waz'));